module.exports = __webpack_public_path__ + "a013055d7063bff9f4a369154d5979fe.ico";